import { z } from "zod";

import { wishlistId, wishlistName } from "./zod-schemas.class";

export const wishlistNameFieldSchema = z.object({
  wishlistName: wishlistName,
});

export const wishlistIdFieldSchema = z.object({
  wishlistId: wishlistId,
});

export const wishlistFieldsSchema = z.union([wishlistNameFieldSchema, wishlistIdFieldSchema]);

export type wishlistNameType = z.infer<typeof wishlistName>;
export type wishlistIdType = z.infer<typeof wishlistId>;
export type wishlistIdFields = z.infer<typeof wishlistIdFieldSchema>;
export type wishlistNameFields = z.infer<typeof wishlistNameFieldSchema>;
export type wishlistFields = z.infer<typeof wishlistFieldsSchema>;
